import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { CountertopUniversityQuiz } from '../types/CountertopUniversityQuiz';
import { profile } from 'console';

export const useGetCountertopUniversityQuiz = (countertopUniversityID: number, profileID?: number | null) => {
    const { data, isLoading, refetch } = useQuery({
        queryKey: ['countertop-university/quiz', countertopUniversityID],
        queryFn: async () => await apiClient.get(`countertop-university/quiz`, {
            params: {
                countertopUniversityID: countertopUniversityID,
                profileID: profileID
            }
        }) as CountertopUniversityQuiz[]
    });

    return {
        data: data || [],
        isLoading,
        refetch: refetch
    };
};
